<template>
  <div id="app" :class="{ 'h-100': route.meta.layout != 'travel', ...skinClasses }" style="min-height:100%">
      <component :is="layout">
        <router-view />
      </component>
  </div>
</template>

<script>


import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { watch, computed} from 'vue'

import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'


import { useRoute } from 'vue2-helpers/vue-router';
import useAuth from '@core/utils/useAuth'

export default {

  components: {
    LayoutFull: () => import('@/layouts/full/LayoutFull.vue'),
    LayoutTravel: () => import('@/layouts/travel/LayoutTravel.vue'),
  },

  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus

    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')

  },


  setup(props) {

    const route = useRoute();
    const contentLayoutType = computed(() => store.state.appConfig.layout.type)
    const layout = computed(() => {
      if (route.meta.layout === 'full') return 'layout-full'
      if (route.meta.layout === 'travel') return 'layout-travel'
      return `layout-full`
      
    })

    const {
      is_loggin
    } = useAuth();

    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()

    watch(windowWidth, (val) => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })


    if (localStorage.getItem('token')) {
        store.commit('usuario/cargarUser', localStorage.getItem('userData'));
    }

    return {
      skinClasses,
      enableScrollToTop,
      layout,
      contentLayoutType,
      route,
      is_loggin,
    }
  }


}
</script>